export default __webpack_public_path__ + "static/media/karma.f6b99266.png";